import accountantList from "pages/HrAdmin/accountant-list";
import {
  GET_CSR_LIST_SUCCESS,
  GET_CSR_LIST_FAIL,
  GET_AUDITOR_LIST_SUCCESS,
  GET_AUDITOR_LIST_FAIL,
  GET_TERRITORIES_LIST_SUCCESS,
  GET_TERRITORIES_LIST_FAIL,
  GET_FINANCE_OFFICER_LIST_SUCCESS,
  GET_FINANCE_OFFICER_LIST_FAIL,
  ADD_STAFF,
  ADD_STAFF_SUCCESS,
  ADD_STAFF_FAIL,
  UPDATE_STAFF_SUCCESS,
  UPDATE_STAFF_FAIL,
  DELETE_STAFF_SUCCESS,
  DELETE_STAFF_FAIL,
  GET_ORGANIZATION_LIST_SUCCESS,
  GET_ORGANIZATION_LIST_FAIL,
  GET_ACCOUNTANT_LIST_SUCCESS,
  GET_ACCOUNTANT_LIST_FAIL,
  GET_DISPATCHER_LIST_SUCCESS,
  GET_DISPATCHER_LIST_FAIL,
  GET_STAFF_LIST,
  GET_STAFF_LIST_SUCCESS,
  GET_STAFF_LIST_FAIL,
  UPDATE_STAFF_LIST_SUCCESS,
  GET_HISTORY_LIST_DISPATCHER_SUCCESS,
  GET_HISTORY_LIST_DISPATCHER_FAIL
} from "./actionTypes";

const INIT_STATE = {
  staff: [],
  staffList: [],
  csrList: [],
  accountantList: [],
  diapatcherList: [],
  activitylogDispatcher: [],
  databaseadminList: [],
  territoriesList: [],
  financeOfficerList: [],
  error: {},
  addStaffError: null,
  addStaffSuccess: null,
  loading: false,
  message: null,
};

const staff = (state = INIT_STATE, action) => {
  switch (action.type) {
    // territories
    case GET_TERRITORIES_LIST_SUCCESS:
      return {
        ...state,
        territoriesList: action.payload.data,
      };

    case GET_TERRITORIES_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_CSR_LIST_SUCCESS:
      return {
        ...state,
        csrList: action.payload.data,
      };

    case GET_CSR_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_AUDITOR_LIST_SUCCESS:
      return {
        ...state,
        databaseadminList: action.payload.data,
      };

    case GET_AUDITOR_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ORGANIZATION_LIST_SUCCESS:
      return {
        ...state,
        databaseadminList: action.payload.data,
      };

    case GET_ORGANIZATION_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_FINANCE_OFFICER_LIST_SUCCESS:
      return {
        ...state,
        financeOfficerList: action.payload.data,
      };

    case GET_FINANCE_OFFICER_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_STAFF:
      return {
        ...state,
        staff: null,
        loading: true,
        addStaffError: null,
        addStaffSuccess: null,
      };
    case ADD_STAFF_SUCCESS:
      return {
        ...state,
        loading: false,
        staff: action.payload,
        addStaffError: null,
        addStaffSuccess: action.payload.staff,
      };
    case ADD_STAFF_FAIL:
      return {
        ...state,
        staff: null,
        loading: false,
        addStaffError: action.payload,
        addStaffSuccess: null,
      };

    case UPDATE_STAFF_SUCCESS:
      return {
        ...state,
        staff: state.staff.map(person =>
          person.id.toString() === action.payload.id.toString()
            ? { person, ...action.payload }
            : person
        ),
      };

    case UPDATE_STAFF_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_STAFF_SUCCESS:
      return {
        ...state,
        staff: state.staff.filter(
          person => person.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_STAFF_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ACCOUNTANT_LIST_SUCCESS:
      return {
        ...state,
        accountantList: action.payload.data,
      };

    case GET_ACCOUNTANT_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_DISPATCHER_LIST_SUCCESS:
      return {
        ...state,
        diapatcherList: action.payload.data,
      };

    case GET_DISPATCHER_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_STAFF_LIST:
      return { ...state, loading: true };

    case GET_STAFF_LIST_SUCCESS:
      return { ...state, loading: false, staffList: action.payload };

    case GET_STAFF_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_STAFF_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        staffList: state.staffList.map(staff =>
          staff.id === action.payload.data.id ? action.payload.data : staff
        ),
      };
   case GET_HISTORY_LIST_DISPATCHER_SUCCESS:
  return {
    ...state,
    activitylogDispatcher: action.payload.data || [],  // ✅ API returns `data`, not `logs`
    error: null,
  };

    case GET_HISTORY_LIST_DISPATCHER_FAIL:
      console.error(
        "[Reducer] Diaptcher History Fetch Failed. Error:",
        action.payload
      );
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default staff;
